import MainSkills from "../../components/Forms/MainSkills";
import IdpTeamplateTab from "../../components/IdpTeamplateTab";
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";

import ListTrainingTable from "./ListTrainingTable";
import MyTeamidpTable from "./MyTeamidpTable";


function MyTeamidp() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <IdpTeamplateTab/>
            </BasicCard>
        </>
    )
}
export default MyTeamidp;